export interface KPIShiftReportRow {
	ProductionDate: string;
	// The legacy branch spells it Starttime, the new one StartTime. Neither is displayed;
	// the totals row is recognised by its empty ProductionDate.
	StartTime?: string;
	Starttime?: string;
	Shift: string;
	Crew: string;
	ActualTPH: number | null;
	TheoreticalTPH: number | null;
	CobbleEvents: number | null;
	CobbleBillets: number | null;
	BilletsBetweenCobbles: number | null;
	CobbleRate: number | null;
	ActualChangeTime: number | null;
	ActualChangeTimeH: number | null;
	ElectricalDowntime: number | null;
	ElectricalDowntimeH: number | null;
	ProductionDowntime: number | null;
	ProductionDowntimeH: number | null;
	MechanicalDowntime: number | null;
	MechanicalDowntimeH: number | null;
	CobbleDowntime: number | null;
	CobbleDowntimeH: number | null;
	UncategorizedDowntime: number | null;
	UncategorizedDowntimeH: number | null;
	DownDayDowntime: number | null;
	DownDayDowntimeH: number | null;
	SumDowntime: number | null;
	SumDowntimeH: number | null;
	Availability: number | null;
	AvailabilityH: number | null;
}

export const isSummaryRow = (row: KPIShiftReportRow): boolean =>
	!row.ProductionDate || row.ProductionDate.trim() === "";
